<template>
    <div>
        <div style="text-align: right">
            <el-button icon="el-icon-plus" type="danger" @click="openCreateConfigDialog">配 置</el-button>
        </div>


        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 10px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="id" label="ID"></el-table-column>
            <el-table-column prop="coinType" label="交易币种"></el-table-column>
            <el-table-column prop="sortNum" label="排序"></el-table-column>
            <el-table-column prop="popularityStatus" label="下架/上架">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.popularityStatus==1?true:false" active-color="#13ce66"
                               inactive-color="#ff4949"
                               @change="alterStatus(scope.row.id, $event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="" label="是否在推荐位展示">
                <template slot-scope="scope">
                    <el-switch :value="scope.row.isShow" active-color="#13ce66" inactive-color="#ff4949"
                               @change="alterShow(scope.row.id, $event)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200px">
                <template slot-scope="scope">
                    <el-button type="primary" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="danger" @click="handleRemove(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <el-form label-width="100px" :model="addData" :rules="addDataRules" ref="addDataForm">
                <el-form-item label="交易币种：" prop="coinType">
                    <el-autocomplete class="inline-input" :disabled="opType==1"
                                     v-model="addData.coinType"
                                     :fetch-suggestions="querySearch"
                                     placeholder="请输入币种">
                        <i class="el-icon-close el-input__icon" slot="suffix"
                           @click="cleanSearchCoin" style="cursor:pointer;">
                        </i>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="排序：" prop="">
                    <el-input-number v-model="addData.sortNum" :min="1" :max="1000000000" label="排序"></el-input-number>
                </el-form-item>
                <el-form-item label="推荐位展示：" prop="isShow">
                    <el-switch v-model="addData.isShow==1?true:false" active-color="#13ce66" inactive-color="#ff4949"
                               @change="handleSwitchChange($event)"></el-switch>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="createConfig">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'popularityConfig',
        data() {
            return {
                dataList: [],
                total: 0,
                addData: {configId: null, configType: 0, isShow: 0, sortNum: 1, coinType: ""},
                addDataRules: {
                    "coinType": [{required: true, message: "币种不能为空"}],
                    "sortNum": [{required: true, message: "序号不能为空"}],
                },
                dialogTitle: "",
                dialogVisible: false,
                coinTypes: [],
                queryParams: { //查询参数
                    configType: 0,
                    page: 1,
                    size: 10
                },
                opType: 0 //0-新增，1-修改
            };
        },
        methods: {
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getPopularityConfigList() {
                api.getEtpCoinConfigList(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            openCreateConfigDialog() {
                this.dialogTitle = "新增";
                this.opType = 0;
                this.dialogVisible = true;
            },
            handleUpdate(row) {
                this.addData = {
                    configId: row.id,
                    configType: 0,
                    isShow: row.isShow ? 1 : 0,
                    sortNum: row.sortNum,
                    coinType: row.coinType
                };
                this.dialogTitle = "修改";
                this.opType = 1;
                this.dialogVisible = true;
            },
            createConfig() {
                this.$refs["addDataForm"].validate(valid => {
                    if (valid) {
                        if (this.opType == 0) {
                            api.saveEtpCoinConfig(this.addData).then(({data}) => {
                                this.dialogVisible = false;
                                this.$message.success('保存成功！');
                                this.getPopularityConfigList();
                            });
                        } else {
                            api.updateEtpCoinConfig(this.addData).then(({data}) => {
                                this.dialogVisible = false;
                                this.$message.success('修改成功！');
                                this.getPopularityConfigList();
                            });
                        }
                    }
                });
            },
            handleRemove(id) {
                this.$confirm('确认删除此配置吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateEtpConfigStatus({configId: id, type: 3, val: 1}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.getPopularityConfigList();
                    });
                }).catch(() => {
                });
            },
            alterStatus(id, status) {
                this.$confirm(status ? '是否确认上架？' : '下架后此交易币种将不在人气榜进行展示，是否确认下架？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateEtpConfigStatus({configId: id, type: 0, val: status ? 1 : 0}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.getPopularityConfigList();
                    });
                }).catch(() => {
                });
            },
            alterShow(id, status) {
                this.$confirm(status ? '确认在推荐位展示吗？' : '确认不在推荐位展示吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.updateEtpConfigStatus({configId: id, type: 2, val: status ? 1 : 0}).then(({data}) => {
                        this.$message.success('操作成功！');
                        this.getPopularityConfigList();
                    });
                }).catch(() => {
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getPopularityConfigList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getPopularityConfigList();
            },
            handleSwitchChange(val) {
                this.addData.isShow = val ? 1 : 0;
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.addData.coinType = '';
            },
            clearData() {
                this.dialogTitle = "";
                this.addData = {configId: null, configType: 0, isShow: 0, sortNum: 1, coinType: ""};
            }
        },
        created() {
            this.getAllSupportCoin();
        }
    };
</script>

<style scoped>

</style>